"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApNotifications = void 0;
var React = require("react");
var ui_utils_1 = require("@alixpartners/ui-utils");
var lodash_1 = require("lodash");
var theme_1 = require("../../utils/theme");
var ApButtons_1 = require("../ApButtons");
var ApContextualPopup_1 = require("../ApContextualPopup");
var ApIcon_1 = require("../ApIcon");
var ApSnack_1 = require("../ApSnack");
var NotificationItem_1 = require("./NotificationItem");
var styles_1 = require("./styles");
var AUTO_HIDE_DELAY = 3000;
var GROUP_THRESHOLD = 4;
var ApNotifications = /** @class */ (function (_super) {
    __extends(ApNotifications, _super);
    function ApNotifications() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            arrowPosition: null,
            contentHeight: null,
            isOpen: false,
            isPushUpdate: _this.props.popNewNotifications || false,
        };
        _this.triggerRef = null;
        _this.setIsOpen = function (isOpen) {
            _this.setState({ isOpen: isOpen });
        };
        _this.afterPopupHide = function () {
            var afterHide = _this.props.afterHide;
            _this.setIsOpen(false);
            if (afterHide) {
                afterHide();
            }
        };
        _this.afterPopupShow = function () {
            var afterShow = _this.props.afterShow;
            _this.setIsOpen(true);
            if (afterShow) {
                afterShow();
            }
        };
        _this.showNewNotifications = function (notifications) {
            var archive = _this.props.archive;
            var pushNotifications = [];
            if (notifications.length >= GROUP_THRESHOLD) {
                pushNotifications = [
                    {
                        content: "You have received " + notifications.length + " new notifications",
                        isGroupped: true,
                        notificationId: lodash_1.uniqueId('notifications'),
                    },
                ];
            }
            else {
                pushNotifications = notifications;
            }
            pushNotifications.forEach(function (item) {
                ApSnack_1.snack.custom({
                    custom: function (hide) {
                        var hideTimeOut;
                        var initTimeout = function () {
                            hideTimeOut = setTimeout(function () { return hide(); }, AUTO_HIDE_DELAY);
                        };
                        var close = function () {
                            clearTimeout(hideTimeOut);
                            hide();
                        };
                        initTimeout();
                        return (React.createElement(styles_1.PushWrapper, { onClick: close, onMouseEnter: function () {
                                clearTimeout(hideTimeOut);
                            }, onMouseLeave: initTimeout },
                            item.isGroupped ? (React.createElement(styles_1.GrouppedNotification, null,
                                React.createElement(ApIcon_1.ApIcon, { iconName: "notification_important", iconColor: theme_1.colors.grey7 }),
                                React.createElement(styles_1.GrouppedText, null, item.content))) : (React.createElement(styles_1.PushNotification, { data: item, archive: archive })),
                            React.createElement(styles_1.CloseWrapper, null,
                                React.createElement(ApButtons_1.ApButtonIcon, { iconName: "baseline_close" }))));
                    },
                    id: item.notificationId,
                    position: 'top-right',
                    suppressHide: true,
                });
            });
        };
        _this.setStyles = function () {
            if (!_this.triggerRef) {
                return;
            }
            var _a = _this.triggerRef.getBoundingClientRect(), width = _a.width, height = _a.height;
            var clientHeight = document.documentElement.clientHeight;
            _this.setState({
                arrowPosition: Math.round(width / 2),
                contentHeight: clientHeight - height - 30,
            });
        };
        _this.fetchNotifications = function () {
            var fetch = _this.props.fetch;
            if (fetch) {
                fetch();
            }
        };
        _this.reFetchNotifications = function () {
            _this.fetchNotifications();
            _this.setState({ isPushUpdate: true });
        };
        return _this;
    }
    ApNotifications.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.setStyles);
        this.setStyles();
        this.fetchNotifications();
    };
    ApNotifications.prototype.componentDidUpdate = function (prevProps) {
        var data = this.props.data;
        var isPushUpdate = this.state.isPushUpdate;
        if (isPushUpdate && !lodash_1.isEqual(prevProps.data, data)) {
            var prevNotificationsIds_1 = prevProps.data.map(function (item) { return item.notificationId; });
            var newNotifications = data.reduce(function (acc, notification) {
                if (!prevNotificationsIds_1.includes(notification.notificationId) &&
                    notification.state === NotificationItem_1.Status.unread) {
                    return __spread(acc, [notification]);
                }
                return acc;
            }, []);
            this.showNewNotifications(newNotifications);
            this.setState({ isPushUpdate: false });
        }
    };
    ApNotifications.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.setStyles);
    };
    ApNotifications.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, className = _a.className, align = _a.align, data = _a.data, iconColor = _a.iconColor, badgeColor = _a.badgeColor, badgeValue = _a.badgeValue, triggerId = _a.triggerId, archive = _a.archive, url = _a.url, accessTokenFactory = _a.accessTokenFactory;
        var _b = this.state, isOpen = _b.isOpen, arrowPosition = _b.arrowPosition, contentHeight = _b.contentHeight;
        var hasNew = !!data.find(function (item) { return item.state === NotificationItem_1.Status.unread; });
        return (React.createElement(styles_1.Wrapper, { ref: function (ref) { return (_this.triggerRef = ref); }, arrowPosition: arrowPosition, contentHeight: contentHeight, align: align, className: "ap-notifications " + (className ? className : '') },
            React.createElement(styles_1.RestyledSnackContainer, null),
            React.createElement(ui_utils_1.ApSignalrConsumer, { message: "NotificationCreated", onMessage: this.reFetchNotifications, onConnectionRestored: this.reFetchNotifications, url: url, accessTokenFactory: accessTokenFactory }),
            React.createElement(ApContextualPopup_1.ApContextualPopup, { id: id, className: "ap-contextual-notifications", trigger: function () { return (React.createElement(styles_1.Trigger, { id: triggerId, active: hasNew && !isOpen, color: badgeColor, text: badgeValue },
                    React.createElement(ApIcon_1.ApIcon, { iconName: "notification_outline", iconColor: isOpen || hasNew ? theme_1.colors.white : iconColor || theme_1.colors.grey4 }))); }, tooltip: {
                    afterHide: this.afterPopupHide,
                    afterShow: this.afterPopupShow,
                    event: 'click',
                    overridePosition: function (_1, currentEvent, currentTarget, node) {
                        var triggerRect = currentTarget.getBoundingClientRect();
                        var left = triggerRect.left, top = triggerRect.top;
                        var width = triggerRect.width, height = triggerRect.height;
                        var d = document.documentElement;
                        left = Math.min(d.clientWidth - node.clientWidth, align === 'right' ? left : left - node.clientWidth + width);
                        top = Math.min(d.clientHeight - node.clientHeight, top + height);
                        left = Math.max(0, left);
                        top = Math.max(0, top);
                        return { top: top, left: left };
                    },
                } }, function () { return (React.createElement(styles_1.Content, null, data.length > 0 ? (data.map(function (item, index) { return (React.createElement(NotificationItem_1.NotificationItem, { key: index, data: item, archive: archive })); })) : (React.createElement(styles_1.NoData, null, "You don't have any notifications right now")))); })));
    };
    ApNotifications.defaultProps = {
        align: 'left',
        data: [],
        id: 'ap-contextual-notifications',
    };
    return ApNotifications;
}(React.Component));
exports.ApNotifications = ApNotifications;
//# sourceMappingURL=ApNotifications.js.map